export const siteUrl = "https://ksiegowydublin.ie"
export const siteName = "D&M Services"
export const defaultImage = `${siteUrl}/banner.jpg`

const defaultDescription =
  "D&M Accountancy Services – polskie biuro księgowe w Irlandii od 2008 roku. Księgowość dla firm, zwrot podatku z P60, ulgi podatkowe, wirtualne biuro. Dublin, Cork i cała Irlandia."

const pages = {
  "/": {
    title: "Polskie biuro księgowe w Dublinie i Cork",
    description: defaultDescription,
  },
  "/o-nas": {
    title: "O nas – polski księgowy w Irlandii od 2008 roku",
    description:
      "Poznaj D&M Services – polskie biuro księgowe działające w Dublinie i Cork od 2008 roku. Doświadczenie, terminowość i zgodność z przepisami Revenue.",
  },
  "/kontakt": {
    title: "Kontakt – biuro księgowe Dublin i Cork",
    description:
      "Skontaktuj się z D&M Services: tel. 016 12 06 20, firmadublin@gmail.com. Biura: Park West, Dublin 12 oraz 33 Cook Street, Cork. Umów bezpłatną konsultację.",
  },
  "/cennik": {
    title: "Cennik usług księgowych w Irlandii",
    description:
      "Przejrzysty cennik usług księgowych D&M Services: księgowość dla sole traderów i spółek, rozliczenia podatkowe, zwrot podatku z P60.",
  },
  "/uslugi": {
    title: "Usługi księgowe w Dublinie i Cork",
    description:
      "Pełen zakres usług księgowych w Irlandii: księgowość dla firm, zwrot podatku z P60, ulgi podatkowe, księgowość korespondencyjna i wirtualne biuro.",
  },
  "/uslugi/dla-firm": {
    title: "Księgowość dla firm – sole trader i spółki",
    description:
      "Kompleksowa księgowość dla firm w Irlandii: rejestracja działalności, rozliczenia VAT, payroll, roczne zeznania podatkowe i kontakt z Revenue.",
  },
  "/uslugi/zwrot-z-p60": {
    title: "Zwrot podatku z P60 w Irlandii",
    description:
      "Odzyskaj nadpłacony podatek w Irlandii. Pomagamy w rozliczeniu P60 / Employment Detail Summary i uzyskaniu zwrotu podatku z Revenue.",
  },
  "/uslugi/ksiegowosc-korespondencyjna": {
    title: "Księgowość korespondencyjna online w Irlandii",
    description:
      "Księgowość online dla firm z całej Irlandii – elektroniczna wymiana dokumentów, bez konieczności wizyt w biurze w Dublinie czy Cork.",
  },
  "/uslugi/ulga-podatkowa": {
    title: "Ulgi podatkowe w Irlandii – odzyskaj pieniądze",
    description:
      "Sprawdź, jakie ulgi podatkowe Ci przysługują w Irlandii: medyczne, na czynsz, na dzieci i inne. Pomagamy odzyskać podatek z Revenue.",
  },
  "/uslugi/wirtualne-biuro": {
    title: "Wirtualne biuro w Dublinie – adres dla firmy",
    description:
      "Wirtualne biuro w Dublinie 12: adres rejestrowy i korespondencyjny dla Twojej firmy, odbiór i obsługa poczty.",
  },
}

export const getSeo = (path) => {
  const normalized = path.length > 1 ? path.replace(/\/+$/, "") : path
  return pages[normalized] || { description: defaultDescription }
}
